import React from 'react';
import './login.scss';
import AuthenticateAPI from '../../apis/authenticate'
import CommonUtils from '../../utility/common-utilities';
import SessionCache from '../routes/session-cache';
import Path from '../routes/routes-path';
import IndexedDBHelperV2 from '../../offline/apis/indexDBManager-v2';
import { Constants, ImageConstants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
import CommonApi from '../../apis/common';
import UpdateBanner from './update-banner/update-banner';
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);


class LogIn extends React.Component {

    constructor(props) {
        super(props);
        this.emailInputRef = React.createRef();
    }

    state = {
        emailId: this.props.signUpEmail ? this.props.signUpEmail : "",
        password: '',
        dot: "",
        isInvalidEmail: false,
        isSubmit: false,
        isInvalidPassword: false,
        selectedLoginType: 'EMAIL',
        selectedCountry: { dialCode: "+91", length: 10, _id: '5f733391ac527316bbd9c539' },
        showDropdown: false,
        isInvalidMobile: false,
        noInternet: false,
        showUpdateBanner: false
    }

    coutryCodeHash = {}

    componentDidMount() {
        if (CommonUtils.isOnline()) {
            this.getCountryCode()
        }

        if (Constants.ELECTRON_BUILD && window.electron && window.electron.onUpdateDownloaded) {
            window.electron.ipcRenderer.send("renderer-ready");
            this.removeUpdateListener =
                window.electron.onUpdateDownloaded((data) => {
                    console.log(data);
                    if (data.currentVersion < data.latestVersion) {
                        this.setState({ showUpdateBanner: true, currentVersion: data.currentVersion, latestVersion: data.latestVersion })
                    }
                });
        }


    }

    updateOnlineStatus = (isOnline) => {
        // Update the state with the current online status
        console.log('login status')

        if (!isOnline) {
            alert('You are offline. Please check your internet connection.');
            CommonUtils.setOffline();
        } else {
            alert('You are back online.');
            CommonUtils.setOnline();
        }
    }


    

    componentWillUnmount() {
        if (this.removeUpdateListener) {
            this.removeUpdateListener();
        }
    }


    onChangeHandler = (event, key) => {

        if (key === 'mobileNumber') {
            if (!this.allowOnlyNumbers(event.target.value)) return
        }

        this.setState({ [key]: event.target.value, invalidCredentials: false, isInvalidMobile: false });
    }

    allowOnlyNumbers(value) {
        const re = /^[0-9\b]+$/;

        if (value === '' || re.test(value)) {
            return true
        }
        return false
    }

    validateMobile(value) {
        if (value) {
            let validate = CommonUtils.validateMobileNumber(value, this.coutryCodeHash[this.state?.selectedCountry?._id])
            //console.log(validate)
            if (validate) {
                return true
            } else {
                this.setState({ isInvalidMobile: true })
            }
        }

        return false
    }



    validateEmail = (event) => {
        const value = event.target.value;
        const isValid = CommonUtils.validateEmail(value);

        if (value && !isValid) {
            this.setState({ isInvalidEmail: true }, () => {
                // Re-focus input for smartboard
                if (this.emailInputRef.current) {
                    this.emailInputRef.current.focus();
                }

            });
        } else {
            this.setState({ isInvalidEmail: false });
        }
    }


    login = () => {
        const emailId = this.state.emailId.trim()
        const password = this.state.password.trim()
        let selectedLoginType = this.state.selectedLoginType
        let isFromElectron = Constants.ELECTRON_BUILD ? true : false


        if (selectedLoginType === 'EMAIL') {
            if (!this.state.emailId || !this.state.password) {
                return;
            }

            this.setState({ isSubmit: true });

            const loadingIntervel = setInterval(() => {
                if (this.state.dot.length === 3) {
                    this.setState({ dot: `.` })
                } else {

                    this.setState({ dot: `${this.state.dot}.` })
                }
            }, 500)

            if (emailId && password && CommonUtils.isOnline()) { 
                let payload = { emailId, password, isFromElectron, selectedLoginType };
                AuthenticateAPI.login(payload).then((response) => {
                    let userDetails = response.data
                    // console.log(userDetails)
                    SessionCache.setUser(userDetails)
                    let cookieItem = { hash: 'session', value: userDetails.hash }
                    dbHelper.updateData(Constants.COOKIE_STORE, cookieItem).then((id) => {
                        console.log('Data added with cookie id:', id);
                        dbHelper.updateData(Constants.STAFF_STORE, userDetails).then((id) => {
                            // console.log('Data added with Staff id:', id);
                        })
                        clearInterval(loadingIntervel)
                        this.setState({ redirectToHome: true, dot: "" })
                        this.props.delegate.goToMenu()
                    })
                }).catch((err) => {
                    console.log("err", err)
                    clearInterval(loadingIntervel)
                    this.setState({ dot: "", invalidCredentials: true })
                    // alert(err, "Invalid credentials");
                    // alert("Invalid credentials! Check your Email Id and Password");
                })
            } else if (emailId && password && !CommonUtils.isOnline()) {
                dbHelper.getAllFromIndex(Constants.STAFF_STORE, 'email', emailId.trim()).then((data) => {
                    console.log('Retrieved data:', data);
                    SessionCache.setUser(data[0]);
                    clearInterval(loadingIntervel)
                    this.setState({ redirectToHome: true, dot: "" })
                    this.props.delegate.goToMenu()

                }).catch(err => {
                    console.log(err)
                    clearInterval(loadingIntervel)
                    this.setState({ dot: "", noInternet: true })
                    // alert(err, "Invalid credentials");
                    alert("No Internet! Please check your internet connection");
                })
            }
        } else if (selectedLoginType === 'MOBILE_NUMBER') {
            const mobileNumber = this.state.mobileNumber
            const countryCode = this.state.selectedCountry.dialCode
            const password = this.state.password.trim()



            //console.log(validate)

            if (!this.state.mobileNumber || !password) {
                return;
            }

            const loadingIntervel = setInterval(() => {
                if (this.state.dot.length === 3) {
                    this.setState({ dot: `.` })
                } else {

                    this.setState({ dot: `${this.state.dot}.` })
                }
            }, 500)


            if (CommonUtils.isOnline()) {

                let validate = CommonUtils.validateMobileNumber(mobileNumber, this.coutryCodeHash[this.state?.selectedCountry?._id])

                if (!validate) return this.setState({ isInvalidMobile: true })

                //console.log(countryCode)

                let payload = {
                    mobileNumber,
                    countryCode,
                    password,
                    selectedLoginType: this.state.selectedLoginType,
                }


                let isFromElectron = Constants.ELECTRON_BUILD ? true : false
                if (!payload.mobileNumber || !payload.countryCode) {
                    return;
                }

                payload.isFromElectron = isFromElectron

                if (mobileNumber && password && CommonUtils.isOnline()) {

                    AuthenticateAPI.login(payload).then((response) => {
                        let userDetails = response.data
                        // console.log(userDetails)
                        SessionCache.setUser(userDetails)
                        let cookieItem = { hash: 'session', value: userDetails.hash }
                        dbHelper.updateData(Constants.COOKIE_STORE, cookieItem).then((id) => {
                            console.log('Data added with cookie id:', id);
                            dbHelper.updateData(Constants.STAFF_STORE, userDetails).then((id) => {
                                // console.log('Data added with Staff id:', id);
                            })
                            clearInterval(loadingIntervel)
                            this.setState({ redirectToHome: true, dot: "" })
                            this.props.delegate.goToMenu()
                        })
                    }).catch((err) => {
                        console.log("err", err)
                        clearInterval(loadingIntervel)
                        this.setState({ dot: "", isInvalidMobile: true })
                        // alert(err, "Invalid credentials");
                        // alert("Invalid credentials! Check your Mobile Number and Password");
                    })
                }
            } else if (mobileNumber && password && !CommonUtils.isOnline()) {
                dbHelper.getAllFromIndex(Constants.STAFF_STORE, 'mobileNumber', mobileNumber).then((data) => {
                    console.log('Retrieved data:', data);
                    SessionCache.setUser(data[0]);
                    clearInterval(loadingIntervel)
                    this.setState({ redirectToHome: true, dot: "" })
                    this.props.delegate.goToMenu()

                }).catch(err => {
                    console.log(err)
                    clearInterval(loadingIntervel)
                    this.setState({ dot: "", noInternet: true })
                    // alert(err, "Invalid credentials");
                    alert("No Internet! Please check your internet connection");
                })
            }
        }



    }

    forgotPassword = () => {
        this.props.delegate?.forgotPassword && this.props.delegate.forgotPassword()
    }

    onClickHere = () => {
        this.props.clickSignup && this.props.clickSignup()
    }

    changeLoginType(type) {
        this.setState({
            selectedLoginType: type,
            isInvalidMobile: false,
            isSubmit: false,
            invalidCredentials: false,
            isLoginFailed: false,
            isInvalidEmail: false,
            mobileNumber: '',
            password: '',
            emailId: '',
            noInternet: false
        })
    }

    getCountryCode(payload = {}) {
        CommonApi.getCountryCode(payload).then((response) => {
            let data = response.response
            console.log(data.length)
            if (data.length) {
                console.log('inside')
                this.setState({ countryList: data })
                this.buildCountryCodeDropDown(data)
            } else {
                this.setState({ countryList: [], countryCodeDropDown: [] })
            }
        }).catch((err) => {
            CommonUtils.setOffline()
            // this.setState({ loading: true }, () => {
            //     setTimeout(() => {
            //         this.setState({ loading: false })
            //     }, 200)
            // })
            // alert("Error while fetching country code. Please try again later.");
            // console.log(err)
        })
    }

    buildCountryCodeDropDown(list = []) {
        let countryCodeDropDown = []
        list.map(item => {
            this.coutryCodeHash[item._id] = item
            countryCodeDropDown.push({ text: item.dialCode, addOn: item.name, value: item._id })
        })

        console.log(countryCodeDropDown)

        this.setState({ countryCodeDropDown, reload: false }, () => {
            this.setState({ reload: true })
        })
    }

    onSelectCode(item) {
        this.setState({ selectedCountry: this.coutryCodeHash[item.value], showDropdown: false }, () => {
            // this.setState({ isLoginEnable: this.validateMobile(this.state.mobileNumber) })
        })

    }

    openCountryCode() {
        if (this.state.isOtpSent) return
        this.getCountryCode()
        this.setState({ showDropdown: !this.state.showDropdown })
    }


    hideCountryDropdown() {
        this.setState({ showDropdown: false })
    }

    onSearch(event) {
        let search = event.target.value
        this.getCountryCode({ name: `/${search}`, })
    }



    countryCodeDropDown(dropDownList = []) {
        return (
            <div className="country-code-drop-down-new" id="st-3" ref={ref => this.countryCodeRef = ref} onClick={() => this.handleClickInside}>
                <div className="">
                    <div className="country-close-icon cursor-pointer">
                        <img className="close-icon" onClick={() => this.hideCountryDropdown()} src={getImageSource(ImageConstants.COUNTRY_CLOSE_ICON)} />
                    </div>
                    <div className="country-header-div">
                        <img className="country-header-img" src={getImageSource(ImageConstants.COUNTRY_DROPDWON_HEADER)} />
                    </div>
                    <div className="select-country">Select a country</div>
                    <div className="country-search-div">
                        <img className="country-search" src={getImageSource(ImageConstants.COUNTRY_CODE_SEARCH_ICON)}></img>
                    </div>

                    <div className="search">

                        <input className="form-control country-search" placeholder={`Search`} value={this.state.search} onChange={(event) => { this.onSearch(event) }} />
                    </div>
                    {
                        this.state.reload ?
                            <div className="p-2 dropdown-scroll">
                                {this.state.countryCodeDropDown.length ?
                                    this.state.countryCodeDropDown.map(dropdown => (
                                        <div className="dropdown-list cursor-pointer px-3 py-1" onClick={() => { this.onSelectCode(dropdown) }}>
                                            <div className="row country-name cursor-pointer">
                                                <div className="col-8"> {dropdown.addOn}</div>
                                                <div className="col text-right">  {dropdown.text}</div>
                                            </div>
                                        </div>

                                    ))
                                    : <div className="text-center py-4 no-data">
                                        <label> No Records found</label>
                                    </div>
                                }
                            </div>

                            :
                            <div className="text-center py-4 no-data">
                                <label> No Records found</label>
                            </div>
                    }

                </div>
                <div className="country-footer-div">
                    <img className="country-header-img" src={getImageSource(ImageConstants.COUNTRY_DROPDWON_FOOTER)} />
                </div>
            </div>
        )
    }



    render() {
        return (
            <div className="login center-box">
                <div className='cw-card'>
                    <div className='cw-card-body'>

                        <div className='d-flex justify-content-around mb-3'>
                            <div className={`cursor-pointer ${this.state.selectedLoginType === 'EMAIL' ? 'selected-type' : 'disabled-text'}`}
                                onClick={() => this.changeLoginType('EMAIL')}>Email</div>
                            <div className={`cursor-pointer ${this.state.selectedLoginType === 'MOBILE_NUMBER' ? 'selected-type' : 'disabled-text'}`}
                                onClick={() => this.changeLoginType('MOBILE_NUMBER')}>Mobile Number</div>
                        </div>


                        {
                            this.state.selectedLoginType === 'EMAIL' ?

                                <div className='row pt-2'>
                                    <div className='col'>
                                        <label className='cw-input-label'>Email ID <span className='star'>*</span></label>
                                        <input className={`cw-input ${this.props.isLoginFailed || (this.state.isInvalidEmail && this.state.emailId) ||
                                            (this.state.isSubmit && !this.state.emailId) ||
                                            this.state.invalidCredentials ? 'invalid' : ''}`}
                                            ref={this.emailInputRef}
                                            placeholder='Enter Your Email Id'
                                            onChange={(e) => this.onChangeHandler(e, 'emailId')}
                                            onBlur={this.validateEmail}
                                            value={this.state.emailId ? this.state.emailId : ""} />

                                        {(this.state.isInvalidEmail && this.state.emailId) || this.props.isLoginFailed ? <span className='invalid-text'>Enter valid email</span> : ''}
                                        {this.state.isSubmit && !this.state.emailId ? <span className='invalid-text'>Please enter email</span> : ''}
                                    </div>
                                </div>

                                :
                                <></>

                        }

                        {
                            this.state.selectedLoginType === 'MOBILE_NUMBER' ?

                                <div className='row pt-2'>
                                    <div className='col'>
                                        <label className='cw-input-label'>Mobile Number <span className='star'>*</span></label>
                                        <div className="cw-input p-1 position-relative" >
                                            <span className={`d-inline-block country-code ${this.state.isOtpSent ? "cursor: default" : "cursor-pointer"}`} onClick={() => this.openCountryCode()}>
                                                {this.state.selectedCountry.dialCode}
                                            </span>
                                            <img className={`country-code-down-arrow cursor-pointer 
                                        ${this.state.selectedCountry.dialCode.length == 3 ? 'country-code-down-arrow-margin' : ''}`}
                                                src={getImageSource(ImageConstants.COUNTRY_CODE_DOWN_ARROW)} onClick={() => this.openCountryCode()} />
                                            <img className="country-code-separator" src={getImageSource(ImageConstants.COUNTRY_CODE_SEPARATOR)} />
                                            <input className="d-inline-block cw-input-1"
                                                placeholder={"Enter Your Mobile Number"}
                                                onChange={event => this.onChangeHandler(event, 'mobileNumber')}
                                                onBlur={(event) => this.validateMobile(event.target.value)}
                                                value={this.state.mobileNumber}
                                            // disabled={this.state.isOtpSent}
                                            />
                                            {this.state.isOtpSent ?
                                                <span className="float-right mr-1 mt-2">
                                                    <img className="cursor-pointer edit-icon-for-login" onClick={() => this.onMobileNumberEdit()} src={getImageSource(ImageConstants.EDIT_ICON_FOR_LOGIN)} />
                                                </span> : ""
                                            }
                                            <div className="abs-div"  >
                                                {this.state.showDropdown ? this.countryCodeDropDown(this.state.countryCodeDropDown) : ""}
                                            </div>

                                        </div>

                                        {(this.state.isSubmit && !this.state.mobileNumber) || this.state.isInvalidMobile ? <div className="invalid-mobilenumber">
                                            Please enter Valid Mobile Number</div> : ''}
                                        {/* <input className={`cw-input ${this.props.isLoginFailed || (this.state.isInvalidEmail && this.state.emailId) ||
                                            (this.state.isSubmit && !this.state.emailId) ||
                                            this.state.invalidCredentials ? 'invalid' : ''}`}
                                            ref={this.mobileNumberInputRef}
                                            placeholder='Enter Your Mobile Number'
                                            onChange={(e) => this.onChangeHandler(e, 'emailId')}
                                            onBlur={this.validateEmail}
                                            value={this.state.emailId ? this.state.emailId : ""} /> */}

                                        {(this.state.isInvalidEmail && this.state.emailId) || this.props.isLoginFailed ? <span className='invalid-text'>Enter valid email</span> : ''}
                                        {this.state.isSubmit && !this.state.emailId ? <span className='invalid-text'>Please enter email</span> : ''}
                                    </div>
                                </div>
                                :
                                <></>
                        }



                        <div className='row bw-spaces-input pt-4'>
                            <div className='col'>
                                <label className='cw-input-label'>Password <span className='star'>*</span></label>
                                <input className={`cw-input ${this.props.isLoginFailed || (this.state.isSubmit && !this.state.password) || this.state.invalidCredentials ? 'invalid' : ''}`}
                                    placeholder='Enter Your Password'
                                    onChange={(e) => this.onChangeHandler(e, 'password')} type='password'
                                    value={this.state.password}
                                />
                                {this.props.isLoginFailed ? <span className='invalid-text'>Enter valid password</span> : ''}
                                {this.state.isSubmit && !this.state.password ? <span className='invalid-text'>Please enter password</span> : ''}
                            </div>
                        </div>

                        {
                            this.state.invalidCredentials ?
                                <div className="text-center pt-4"><span className='register-link text-center pt-1'>Check your Email Id & Password</span></div>
                                : ""
                        }

                        {
                            this.state.noInternet ?
                                <div className="text-center pt-4"><span className='register-link text-center pt-1'>Check your Internet Connection !!!</span></div>
                                : ""

                        }

                        {/* <div className='row bw-spaces-input pt-4'>
                            <div className='col text-right'>
                                <span className='forgot-password-link cursor-pointer p-2' onClick={this.forgotPassword.bind(this)}>Forgot Password?</span>
                            </div>
                        </div> */}
                    </div>

                    <div className='cw-card-footer ' onClick={this.login.bind(this)}>
                        <span className='footer-text'>Log In{this.state.dot}</span>
                    </div>

                </div>

                {/* <div className="row pt-5">
                    <div className="col text-center">
                        <span className="not-register">  <span>If you are not registered, </span> <span className="click-here" onClick={this.onClickHere}> CLICK HERE</span></span>
                    </div>
                </div> */}
                {
                    this.state.showUpdateBanner ?
                        <UpdateBanner

                            visible={this.state.showUpdateBanner}

                            currentVersion={this.state.currentVersion}

                            latestVersion={this.state.latestVersion}

                            onRestart={() => {
                                window.electron.restartAndUpdate();
                            }}

                            onLater={() => {

                                window.electron.dismissUpdateBanner();

                                this.setState({
                                    showUpdateBanner: false
                                });

                            }}

                        />
                        :
                        <></>
                }

            </div >
        );
    }
}

export default LogIn;